module.exports = __webpack_public_path__ + "img/login_bg.396a7b48.png";